import { useMemo, useState } from 'react'

export interface IDataType {
  dhDeliveryKpiType?: {
    options: {
      id: string
      parentId: string
      displayName: string
    }[]
    value: string[][]
  }
}

const useDhDeliveryKpiType = (): IDataType => {
  const dhDeliveryKpiTypeHook = useState([['orderWithAnyIssuePercent']])

  return {
    dhDeliveryKpiType: useMemo(() => {
      const options = [
        {
          id: 'orderWithAnyIssuePercent',
          parentId: 'root',
          displayName: '% Orders w/ Any Issues',
        },
        {
          id: 'orderWithAccuracyIssuePercent',
          parentId: 'root',
          displayName: '% Orders w/ Accuracy Issues',
        },
        {
          id: 'orderWithCancellationsIssuePercent',
          parentId: 'root',
          displayName: '% Orders w/ Cancellations Issues',
        },
        {
          id: 'orderWithLatenessIssuePercent',
          parentId: 'root',
          displayName: '% Orders w/ Lateness Issues',
        },
        {
          id: 'combinedStarRating',
          parentId: 'root',
          displayName: 'Combined Star Rating',
        },
        {
          id: 'customerPositiveRatingCountPercent',
          parentId: 'root',
          displayName: '% Like and Love',
        },
      ]

      return {
        value: dhDeliveryKpiTypeHook[0],
        options: options,
        onChange: dhDeliveryKpiTypeHook[1],
      }
    }, [dhDeliveryKpiTypeHook]),
  }
}

export default useDhDeliveryKpiType
